"use strict";

import Vue from 'vue';
import vueCookie from 'vue-cookie'
import moment from 'moment'
import {validateSpecialRBTimer} from '@/js/common/rb-timer'


var merdianFn = function (hour, minute, isLowercase) {
  if (hour < 12) {
      return "AM";
  } else {
    return 'PM'
  }
}
switch(vueCookie.get(compcode+ '_lang')) {
  case 'zh_CN':
    require('moment/locale/zh-cn')
    moment.locale('zh-cn')
    moment.updateLocale('zh-cn', {
      longDateFormat: {
        MM : 'xx'
      },
      meridiem : merdianFn
    })
  break;
  case 'zh_TW':
    require('moment/locale/zh-tw')
    moment.locale('zh-tw')
    moment.updateLocale('zh-tw', {
      meridiem : merdianFn
    })
  break;
  case 'th_TH':
    require('moment/locale/th')
    moment.locale('th')
    moment.updateLocale('th', {
      meridiem : merdianFn
    })
  break;
  case 'vn_VN':
    require('moment/locale/vi')
    moment.locale('vi')
    moment.updateLocale('vi', {
      // monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split('_'),
      monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      meridiem : merdianFn
    })
  break;
  case 'id_ID':
    require('moment/locale/id')
    moment.locale('id')
    moment.updateLocale('id', {
      meridiem : merdianFn
    })
  break;
  case 'es_MX':
    require('moment/locale/es')
    moment.locale('es')
    moment.updateLocale('es', {
      meridiem : merdianFn
    })
  break;
  case 'pt_PT':
    require('moment/locale/pt')
    moment.locale('pt')
    moment.updateLocale('pt', {
      meridiem : merdianFn
    })
  break;
  case 'fa_IR':
    require('moment/locale/fa')
    moment.locale('fa')
    moment.updateLocale('fa', {
      meridiem : merdianFn
    })
  break;
  case 'ja_JP':
    require('moment/locale/ja')
    moment.locale('ja')
    moment.updateLocale('ja', {
      meridiem : merdianFn
    })
  break;
  case 'ko_KR':
    require('moment/locale/ko')
    moment.locale('ko')
    moment.updateLocale('ko', {
      meridiem : merdianFn
    })
  break;
  default: //en_US
    moment.updateLocale('en_US', {
      meridiem : merdianFn
    })
}
Vue.filter('date', function(value, format) {
  var paramDate = new moment(value)
  return paramDate.format(format);
})

/**
 * Format 
 */
Vue.filter('rb-timer', function(event, format) {
  var timer = ''

  if(event.sptid == '1'){
    var timerSec = moment.duration(event.rbinfo.tlsec,'seconds').seconds()
    var timerMin = moment.duration(event.rbinfo.tlsec,'seconds').minutes()
    var timerHour = moment.duration(event.rbinfo.tlsec,'seconds').hours()
    
    if(timerSec.toString().length == 1) {
      timerSec = '0' + timerSec
    }
    
    timer = timerMin
    if(event.rbinfo.htst == '2') {
      if(event.extraflag) { //this is for extra time events
        timer = timerMin >= 15 ? timerMin - 15 : timerMin
      } else {
        timer = ((timerHour * 60) - 45) + timerMin
      }
    }

    if(validateSpecialRBTimer(event, timerHour, timerMin)) {
      timer = (timerHour * 60) - 45 + timerMin
    }

    if(timer.toString().length == 1) {
      timer = '0' + timer
    }

    if(format == 'mm:ss') {
      timer += ':' + timerSec
    } else if (format == 'mm') {
      timer = timer
    } else {
      //is 2nd half
      timer = timer
    }

  }else if(event.sptid == '2'){
    var timerMin = event.rbinfo.evetm

    if(timerMin.toString().length == 1) {
      timerMin = '0' + timerMin
    }

    timer = timerMin

    if(format == 'mm:ss') {
      timer += ':00'
    } else if (format == 'mm') {
      timer = timer
    } else {
      timer += ':00'
    }
    
  }

  return timer;
})

Vue.filter('checkTimer', function(event, format) {
  var timer = ''

  if(event.sptid == '1'){
    var timerSec = moment.duration(event.rbinfo.tlsec,'seconds').seconds()
    var timerMin = moment.duration(event.rbinfo.tlsec,'seconds').minutes()
    var timerHour = moment.duration(event.rbinfo.tlsec,'seconds').hours()
    
    if(timerSec.toString().length == 1) {
      timerSec = '0' + timerSec
    }
    
    timer = timerMin
    if(event.rbinfo.htst == '2') {
      if(event.extraflag) { //this is for extra time events
        timer = timerMin >= 15 ? timerMin - 15 : timerMin
      } else {
        timer = ((timerHour * 60) - 45) + timerMin
      }
    }

    if(validateSpecialRBTimer(event, timerHour, timerMin)) {
      timer = (timerHour * 60) - 45 + timerMin
    }

    if(timer.toString().length == 1) {
      timer = '0' + timer
    }

    if(timer < 0){
      timer = ''
    }else{
      if(format == 'mm:ss') {
        timer += ':' + timerSec
      } else if (format == 'mm') {
        timer = timer
      } else {
        //is 2nd half
        timer = timer
      }
    }

  }else if(event.sptid == '2'){
    var timerMin = event.rbinfo.evetm

    if(timerMin){
      if(timerMin.toString().length == 1) {
        timerMin = '0' + timerMin
      }
    }else{
      timerMin = -1;
    }

    timer = timerMin

    if(timer < 0){
      timer = ''
    }else{
      if(format == 'mm:ss') {
        timer += ':00'
      } else if (format == 'mm') {
        timer = timer
      } else {
        timer += ':00'
      }
    }
    
  }

  return timer;
})


// WEBPACK FOOTER //
// ./resources/wob/vue/filters/date.js